const iosPwaPrompt = (state = true, action) => {
	switch (action.type) {
		case 'IOS_PWA_PROMPT_OFF':
			return false
		default:
			return state
	}
}

export default iosPwaPrompt

export const getIosPwaPrompt = state => state.iosPwaPrompt